import _ from 'lodash';
import { createContext, useContext, useReducer, useState } from 'react';

const ModalContext = createContext(null);

export function ModalProvider({ children }) {
  const [openModals, setOpenModals] = useState({});

  const initialValue = {
    setOpen: (modalId, isOpen) => {
      setOpenModals((openModals) => ({ ...openModals, [modalId]: isOpen }));
    },
    isOpen: (modalId) => {
      return openModals[modalId];
    },
  };

  return <ModalContext.Provider value={initialValue}>{children}</ModalContext.Provider>;
}

export function useModal() {
  return useContext(ModalContext);
}
